
/**
 * A helper function that helps validate exclusions of a unit
 */
 class ExclusionValidator {

   static exclusionClashTest(unit, allUnitCodes, requirements) {
      //no requirements, just return
      if (!requirements)
         return true;

      if (requirements.or) {
          if (requirements.or.some(r => this.exclusionClashTest(unit, allUnitCodes, r))) {
              return true;
          }
      }
      else if (requirements.and) {
          if (requirements.and.every(r => this.exclusionClashTest(unit, allUnitCodes, r))) {
              return true;
          }
      }
      else {
          if (allUnitCodes.some(a => a == requirements)) return true;
      }

      return false;
    }
}

module.exports = ExclusionValidator
